import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { User } from 'src/app/domain/user';
import { UserService } from 'src/app/services/user.service';
import { StringTool } from '../../mapping/string.tool';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-new-customer-box',
    templateUrl: './new-customer-box.component.html',
    styleUrls: ['./new-customer-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NewCustomerBoxComponent implements OnInit {
    public ValidEmail = new UntypedFormControl('', Validators.compose([
        Validators.required,
        Validators.pattern(/([a-zA-Z0-9_.+-]{5,})@([a-zA-Z0-9-\.]+)(\.[a-zA-Z0-9]{2,3})/g)]));
    Model: User = new User();



    constructor(
        public dialogRef: MatDialogRef<NewCustomerBoxComponent>,
        @Inject(MAT_DIALOG_DATA) public data) {

    }

    ngOnInit(): void {
        this.ValidEmail.markAsPending();

    }

    setCreationMode() {
        this.Model = new User();
    }

    CanSave() {

        return StringTool.isNotNullOrEmpty(this.Model.FirstName)
            && StringTool.isNotNullOrEmpty(this.Model.LastName)
            && StringTool.isNotNullOrEmpty(this.Model.Phone)
            && StringTool.isNotNullOrEmpty(this.Model.CompanyName)
            && StringTool.isNotNullOrEmpty(this.Model.Email)
            && this.ValidEmail.valid;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        if (this.CanSave())
            this.dialogRef.close(this.Model);

    }

    public compareUserWith(m1: User, m2: User) {
        return m1 && m2 ? m1.Email === m2.Email : m1 === m2;
    }
}
